export default __webpack_public_path__ + "static/media/qb.ba6c0ffd.webp";